// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"color-picker-dialogue_wrapper__3QRUu","paper":"color-picker-dialogue_paper__2H1FN","dheader":"color-picker-dialogue_dheader__aRiLE"};